module.exports = __webpack_public_path__ + "static/traditional-flush-window-a88cf559d49a18e7f2398f8df0a667c5.jpg";